import { useState, useEffect } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';

import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography
} from '@material-ui/core';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { addFileRef} from 'src/redux/actions/user.actions';



const useStyles = makeStyles((theme) => ({
  input: {
    display: 'none',
  },
}));

const AccountProfile = (props) => { 
  const classes = useStyles();
  const dispatch = useDispatch();


  const handleUpload = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    dispatch(addFileRef(formData, props.ids))
    .then(data => {
    })
    .catch(err => {
    })
  };


  return (
    <>
    <input
        accept="image/*"
        className={classes.input}
        onChange={handleUpload}
        id="profile-button-fil1e"
        multiple
        type="file"
      />
  <Card {...props}>
    <CardContent>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <img
    src={props.image}
    width="100%"
    height="220px"
    className="mb-3"
    />
        <Typography
          color="textPrimary"
          gutterBottom
          variant="h5"
        >
        {props.title}
        </Typography>
      </Box>
    </CardContent>
    <Divider />
    <label className="col p-0" htmlFor="profile-button-fil1e">
    <CardActions>
        <Button
        color="primary"
        fullWidth
        variant="text"
        component="span"
        className="pb-0"
      >
        Upload picture
      </Button>
    </CardActions>
    </label>
  </Card>
  </>
)
};

export default AccountProfile;
